import { IWorkingDays } from '@interfaces/cmModule/operationWindowRules';
import { IIsChecked } from '@interfaces/common/common';
import { TRequiredSelectOption } from '@interfaces/components/componentTypes';

import { EWeekDayNames, EWeekDayTitles } from '@enums/common';

export const operationRulesWeekOptions: TRequiredSelectOption<string, IIsChecked>[] = [
	{
		label: EWeekDayTitles.monday,
		value: EWeekDayNames.monday,
		isChecked: false,
	},
	{
		label: EWeekDayTitles.tuesday,
		value: EWeekDayNames.tuesday,
		isChecked: false,
	},
	{
		label: EWeekDayTitles.wednesday,
		value: EWeekDayNames.wednesday,
		isChecked: false,
	},
	{
		label: EWeekDayTitles.thursday,
		value: EWeekDayNames.thursday,
		isChecked: false,
	},
	{
		label: EWeekDayTitles.friday,
		value: EWeekDayNames.friday,
		isChecked: false,
	},
	{
		label: EWeekDayTitles.saturday,
		value: EWeekDayNames.saturday,
		isChecked: false,
	},
	{
		label: EWeekDayTitles.sunday,
		value: EWeekDayNames.sunday,
		isChecked: false,
	},
];

export const defaultOperationRulesSchedule: IWorkingDays[] = [
		{
			categoryName: EWeekDayNames.monday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.monday,
				title: EWeekDayTitles.monday,
				shortTitle: 'Mon',
			},
			ranges: [],
		},
		{
			categoryName: EWeekDayNames.tuesday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.tuesday,
				title: EWeekDayTitles.tuesday,
				shortTitle: 'Tue',
			},
			ranges: [],
		},
		{
			categoryName: EWeekDayNames.wednesday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.wednesday,
				title: EWeekDayTitles.wednesday,
				shortTitle: 'Wed',
			},
			ranges: [],
		},
		{
			categoryName: EWeekDayNames.thursday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.thursday,
				title: EWeekDayTitles.thursday,
				shortTitle: 'Thu',
			},
			ranges: [],
		},
		{
			categoryName: EWeekDayNames.friday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.friday,
				title: EWeekDayTitles.friday,
				shortTitle: 'Fri',
			},
			ranges: [],
		},
		{
			categoryName: EWeekDayNames.saturday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.saturday,
				title: EWeekDayTitles.saturday,
				shortTitle: 'Sat',
			},
			ranges: [],
		},
		{
			categoryName: EWeekDayNames.sunday,
			isEnabled: false,
			weekDay: {
				name: EWeekDayNames.sunday,
				title: EWeekDayTitles.sunday,
				shortTitle: 'Sun',
			},
			ranges: [],
		},
	];
